/*
 * Author: Stephen Aranda
 * File  : manager-actions.jsx
 * Desc  : api calls for the manager user type
 * * */

import AxiosWithAuth from "../../components/utils/axios-with-auth";

export const MANAGER_START = "MANAGER_START";
export const MANAGER_SUCCESS = "MANAGER_SUCCESS";
export const MANAGER_FAILURE = "MANAGER_FAILURE";

// api call to retrieve total daily transactions
//@date: The param date in which you want to retrieve the daily transactions
//@navigate: param navigate to daily after successful retrieval
export const getTotalDailyTransactions = (date) => async (dispatch) => {


    try {

        // dispatch start of action
        dispatch({ type: MANAGER_START });




        // make the api call and save the response data
        const response = await AxiosWithAuth().post('api/users/daily', date);

        // dispatch success and assign the response data to payload
        dispatch({ type: MANAGER_SUCCESS, payload: response.data });

        // display pop with the total daily transactions
        alert(`Total Daily Transactions: ${response.data[0].count}`)


    } catch (error) {
        // dispatch failure and failure message
        dispatch({ type: MANAGER_FAILURE, payload: error.message });
    }

}

// api call to retrieve total weekly transactions
//@date: The param date in which you want to retrieve the weekly transactions
//@navigate: param navigate to weekly after successful retrieval
export const getTotalWeeklyTransactions = (date) => async (dispatch) => {


    try {

        // dispatch start of action
        dispatch({ type: MANAGER_START });

        const response = await AxiosWithAuth().post('/api/users/weekly', date)

        // dispatch success and assign response data to payload.
        dispatch({ type: MANAGER_SUCCESS, payload: response.data });

        // display pop with the total daily transactions
        alert(`Total Weekly Transactions: ${response.data[0].count}`)

    } catch (error) {
        // dispatch failure and failure message
        dispatch({ type: MANAGER_FAILURE, payload: error.message });
    }

}

export const getTotalMonthlyTransactions = (date) => async (dispatch) => {

    try {

        // dispatch start of action
        dispatch({ type: MANAGER_START });


        //make api call and save response 
        const response = await AxiosWithAuth().post('/api/users/monthly', date);

        // dispatch success and assign response data to payload
        dispatch({ type: MANAGER_SUCCESS, payload: response.data });

        // display via pop up window
        alert(`Total Monthly Transactions: ${response.data[0].count}`)

    } catch (error) {
        // dispatch failure and failure message
        dispatch({ type: MANAGER_FAILURE, payload: error.message });
    }
}